<template>
  <div class="container adlcj">
    <div class="row twoColumn itemCenter">
      <b-col class="twoColumnText">
        <p>
          ADLCJ、日本語・日本文化振興協会は、日本・日仏子女の日本語教育を目的として、1988年に設立されました。
          本校では、日本の学習指導要領に準拠した国語および算数の補習授業を行なっています。
        </p>
        <p>
          本校の運営は、会長と児童保護者から成る運営委員によって全てボランティアで行われ、年間の活動もまた、児童保護者の方々の協力の元に成り立っています。
          <br />経験豊かな講師陣を抱え、人数の多いクラスにはアシスタントとしてバイリンガル教育に興味のある学生の方などにボランティアで参加して頂いています。
        </p>
        <p>所在地のVilleurbanne市では、日本文化を紹介するアトリエ開催や、夏祭りに参加するなどして、地元との交流を大切にしています。
          <a
              href="https://www.facebook.com/Adlcjlyonhoshujyugyoko/"
              class="facebookLink"
              target="_blank"
              rel="noopener noreferrer"
            >Facebookページ</a>ではADLCJの最新活動情報を発信しています。</p>
      </b-col>
    </div>
    
    <section class="row boxShadow">
      <b-col cols="12" md="6" class="col colImageLeft">
        <img
          src="../assets/image/photos/remiseduprix.jpg"
          alt="Remise du prix du Ministre des Affaires étrangères à Madame MARRET, la présidente de l'ADLCJ"
        />
      </b-col>
      <b-col cols="12" md="6" class="colTextRight">
        <h2>外務大臣表彰受賞</h2>
        <p>2020年1月15日、リヨン補習授業校会長のマレ比彩乃先生が、長年の日本語教育および日仏友好親善活動に対し、その功績が評価されて外務大臣表彰を受賞されました。</p>
        <p>マレ先生は、1988年に日本人家庭や日仏家庭の子供たちが日本語を学べる場として日本語補習校を設立し、本校のボランティア理事を28年の長きに亘って務めておられます。日本語教育推進に向けた長年の努力が外務大臣表彰受賞という素晴らしい形で認められました。マレ先生のこれまでのご貢献に感謝申し上げると共に、この度の外務大臣表彰受賞を心からお祝いいたします。</p>
      </b-col>
    </section>
    <section class="row boxShadow">
      <div class="oneText">
        <h2>皇太子殿下リヨンご訪問</h2>
        <p>2018年9月8日、リヨン補習授業校は皇太子殿下をお迎えいたしました。</p>
        <p>
          会長と校長から簡単な学校説明を差し上げた後、まず、幼稚園年長クラスの授業を10分ほどご見学いただきました。
          子どもたちは、緊張の色は微塵もなく、うどんの写真を見て、「パスタ！ そうめん！」と大声を上げていました。
          <br />殿下からは教材についてのご質問がありました。
          <br />次に小中学部の代表18名による学習発表会を20分間、ご見学になりました。
        </p>
        <p>因みにプログラムは</p>
        <p>
          小1・小2、8名による「おむすび、ころりん」朗読
          <br />小3・小4、6名による作文「もしもひとつ、ねがいがかなうなら」朗読
          <br />小6・中1、2名による詩の朗読
          <br />中2、2名による寸劇「30年後のぼくたち」
          <br />
        </p>
        <p>
          生徒たちは皆、間違えることなく、堂々とした態度ではきはきと発表することができました。
          <br />殿下は子どもたちの発表をお聞きになりながら、時々、「うん、うん」と、発表を噛み締めておいでのようでした。
          殿下から最後、多くの子どもたちに、お声がけがありました。
          <br />「勉強は大変ですか。」「いえ、大丈夫です。」 ？？？！！！！（それは結構なことです。）
        </p>
        <p>
          子どもたちにとっては一生の思い出になることでしょう。
          <br />折しも、リヨン補習授業校30周年という節目の年に 補習校の歴史にすばらしい1ページを加えることが出来ました！
        </p>
        <br />
        <p>
          <strong>外部リンク：</strong>
          <br />
          <br />
          <a
            href="https://www.leprogres.fr/rhone-69-edition-lyon-metropole/2018/09/08/le-prince-heritier-japonais-a-entame-sa-visite-de-lyon"
            target="_blank" rel="noopener"
          >ル・プログレ掲載記事</a>
          <br />
          <a
            href="https://fr-fr.facebook.com/japon.consulat/posts/670568576658681?__tn__=H-R"
            target="_blank" rel="noopener"
          >在リヨン日本領事事務所 Facebook掲載記事</a>
        </p>
      </div>
    </section>
    <section class="row boxShadow">
      <div class="oneText">
        <h2>30周年記念文集</h2>
        <p>
          リヨン補習授業校の３０周年を記念して、本校卒業生に作文を書いて頂きました。
          <br />その中から一つご紹介します。
        </p>
        <div class="oneCompo">
          <h3>レマン湖の鬼ババ</h3>
          <h4>寺田さほり</h4>
          <p>
            「おはよう、よく寝た？今朝は何食べるの？」
            <br />「おはよう。おもちとジジの卵と海苔いっぱい」
          </p>
          <p>私と子供たちの朝は、毎日こんな会話で始まります。</p>
          <p>フランス生まれで、日本には生まれてから一度しか「帰った」ことのない美亜（１１歳）と建斗（８歳）は、食文化から言うと日本人ですし、母国語というか、正確に言えば母親と話す言葉という点からも日本人です（とはいえ彼らにとっては英語とフランス語の方がずっと楽なのですが）。</p>
          <p>私自身は６歳からずっとフランスで育ち、教育もすべてフランスで受けていますから、日本語は私の主たる言語ではありませんし、その後アメリカ人と結婚し、国連で働いていることもあって、第二外国語でさえありません。でも、子供たちと交わす言葉として私が選んだのは、日本語なのです。</p>
          <p>なぜでしょう？ ジュネーヴというフランス語と英語環境の中で暮らしているのですから、楽だからという理由ではありません。将来私や子供たちが日本で暮らす可能性はほとんどありませんから、合理的な計算という理由でもありません。この選択の一番大きい理由は、日本語とは私にとって、かつても今も「うちで話す言葉」であるという私と日本語との情緒的な関係から説明がつくと思います。フランス語を全く知らずに６歳でこの国に到着、口内炎だらけになりながら一年間学校では一切口をきかなかった私にとって、家だけが安心して好きなように自分を表現できる場でした。こうした安心感、また、こうした最初のカルチャーショックのおかげでその後私が徐々に作り上げていった私自身の多文化的アイデンティティーの根っこを、日本語を通して子供たちに伝えたかったからだろうと思うのです。</p>
          <p>勿論、絶えざる努力、根くらべの戦い、日常茶飯の言い争い無しではすみません。毎土曜、友達がショッピングや映画に行っている時、リヨンの補習校に行かなければならないわが身を大いに親に文句を言った自分を思い出します。現在は、私が土曜の朝ジュネーヴの補習校に行くため７時半に子供たちを起こしているレマン湖の鬼ババです。さらにひどいことに、漢字・九九、さらには百人一首を学ばせようと、毎日必ず３０分（日曜は一時間半）宿題をする時間を課しています。彼らは恐らく生涯をヨーロッパで過ごすことになるというのに。</p>
          <p>しかし、私の子供たちが日本文化に間接的にでも触れられるのは補習校のおかげです。規律、年長者への敬意、時間に正確であること、こうしたことは彼らが通っている私立のバイリンガル校の積極的で自由な教育法の中では想像もつかないことでしょう。また、彼らの日常の中では、運動会や友達と食べるお弁当、ドラエモンは、ジュネーヴの典型的なお祭り「エスカラード」やアメリカ・ウイスコンシン州製アイスクリームと同じ重要性を持っています。このように様々な文化レパートリーの中から自由に何かを汲み取る能力こそ、真の世界市民を生み出すのではないでしょうか！</p>
          <p>周囲を見まわしてみると、私は子供と日本語で話すという選択をした数少ない「二世」の一人のようです。それは私が他の人より断固としているわけでも、よく日本語が出来るからでもありません。（それどころかリヨン補習校の先生方なら私の貧しい日本語力を口を揃えて認めることでしょう。）それは単に私が両親、特に娘の教育のために日本の大企業でのキャリアを捨ててフランスに残った父親に、孫たちと日本語で話せるようにしてあげたかったからなのです。また、それが出来たのはアメリカ人の夫のおかげでもあります。彼は私の国連でのポストが変わる度に従いてきてくれ、キャリアを支えてくれたたように、この私の選択を支持し、食卓では父親とは英語、母親とは日本語、フランス語は学校で、と、三か国語を混ぜないよう「言語ポリス」をしてくれています。</p>
          <p>あれから数十年を過ごした今、私は両親が私の毎週の文句や親子共に要求された過剰な努力にもかかわらず、なぜ補習校を続けさせたがったかがようやく分かるようになりました。</p>
          <p>結局の所、日本語は私にとって学ぶべき言語というだけではありません。それは私がどこから来て、どこへ向かうのかを悟らせてくれる、世代を繋ぐ愛情の絆なのです。</p>
        </div>
      </div>
    </section>
  </div>
</template>


<script>
export default {
  name: "AdlcjJA",
};
</script>

<style lang="scss" scoped>
.boxShadow {
  @media (max-width: 767px) {
    flex-direction: column;

    .col {
      width: 100%;
      padding-left: 0;
      padding-right: 0;
    }

    .colImageLeft img {
      width: 100%;
      height: auto;
    }
  }
}

.facebookLink {
  display: inline-block;
  font-weight: 600;
  color: $linkColor;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}
</style>